import type { ReactNode } from "react";
import { Label } from "./label";
import { cn } from "@/lib/utils";

interface FieldProps {
  id: string;
  label: string;
  error?: string;
  helper?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Vertical form field: label · control · helper/error line.
 * Used by every form in the app so spacing, error color, and label
 * treatment stay identical everywhere.
 */
export function Field({ id, label, error, helper, className, children }: FieldProps) {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <Label htmlFor={id}>{label}</Label>
      {children}
      {error ? (
        <p role="alert" className="text-[12px] text-danger">
          {error}
        </p>
      ) : helper ? (
        <p className="text-[12px] text-ink-subtle">{helper}</p>
      ) : null}
    </div>
  );
}
